export const validateRows = (rows = [], config = {}) => {
  const fieldRules = config?.fieldRules || {};

  const requiredFields = Object.entries(fieldRules)
    .filter(([key, rule]) => rule?.required)
    .map(([key]) => key);

  const errors = [];

  rows.forEach((row, rowIndex) => {
    requiredFields.forEach((field) => {
      const value = row?.[field];

      if (value === undefined || value === null || value === "") {
        errors.push({
          row: rowIndex + 1,
          field,
        });
      }
    });
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};
